import { render, staticRenderFns } from "./classTab.vue?vue&type=template&id=5ebf3a25&scoped=true"
import script from "./classTab.vue?vue&type=script&lang=js"
export * from "./classTab.vue?vue&type=script&lang=js"
import style0 from "./classTab.vue?vue&type=style&index=0&id=5ebf3a25&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ebf3a25",
  null
  
)

export default component.exports